import request from '@/api/request'
/**
 * 获取公证处列表
 */
export function orgListApi (query) {
  return request({
    url: '/org/list',
    method: 'get',
    params: query
  })
}
/**
 * 获取公证处详情
 */
export function orgInfoApi (query) {
  return request({
    url: '/org/info',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/org/index.js